// SEE-1787: SSO redirects back to whichever host served the app, not a build-time domain, so
// one build works on both its pre-cutover `next.` hostname and the live one. Cognito still
// accepts only the URLs on the app client's callback and sign-out lists. The mobile app is
// unaffected: it swaps in its own `<scheme>://sso-callback` redirect (speedchain-mobile
// ssoAuthSession.ts).
const aws_auth = {
  oauth: {
    domain: process.env.REACT_APP_COGNITO_DOMAIN,
    scopes: ['openid', 'email', 'phone', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: `${window.location.origin}/login/`,
    redirectSignOut: `${window.location.origin}/logout/`,
    responseType: 'code',
  },
};

export default aws_auth;
